import React, { Component } from "react";
import { matchPath } from "react-router";
import { Layout, Menu, message, Icon } from "antd";
import { menuByRouteName, routes, flatRouteMap } from "router";
import Header from "components/Header";
import { breadcurmbs } from "components/Breadcrumb";
import Loading from "components/Loading";
import { Link } from "react-router-dom";
import { get } from "lodash";
import "./app.scss";

message.config({
  top: 74,
});

export default class App extends Component {
  state = {
    collapsed: false,
    loading: false,
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  render() {
    let pageKey = "",
      routeObj = { params: {} };
    const { collapsed } = this.state;

    const keys = Object.keys(routes);

    for (let key of keys) {
      if (!routes[key].path) continue;
      const matched = matchPath(this.props.location.pathname, {
        path: routes[key].path,
      });
      if (matched) {
        pageKey = key;
        routeObj = matched;
        break;
      }
    }

    if (this.state.loading) {
      return <Loading></Loading>;
    }
    let _routeMap = flatRouteMap[pageKey] || [];
    const selectedKey = get(routes, `[${_routeMap[0]}].path`);

    return (
      <Layout>
        <Layout.Sider
          theme="light"
          collapsible
          breakpoint="lg"
          // collapsedWidth="80"
          collapsed={collapsed}
          onCollapse={this.onCollapse}
        >
          <span
            className="ant-layout-sider-zero-width-trigger ant-layout-sider-zero-width-trigger-left"
            onClick={() => this.onCollapse(!collapsed)}
          >
            <Icon type="bars"></Icon>
          </span>

          <Menu theme="light" mode="inline" selectedKeys={[selectedKey]}>
            <Menu.Item key="banner">
              <Link to="/net-zero/home">
                <div className="logo"></div>
              </Link>
            </Menu.Item>
            {[
              "HomeEdit",
              "NationList",
              "ImageList",
              "FileList",
              "ActivityList",
              "VideoList",
            ].map((r) => menuByRouteName(r))}
          </Menu>
        </Layout.Sider>

        <Header
          location={this.props.location}
          handleClick={this.handleClick}
          {...this.props}
        />

        <Layout className="fixed-header fixed-sider">
          {routes[pageKey]?.showBreadcrumb &&
            breadcurmbs(pageKey, routeObj.params.id === "create")}
          <Layout.Content>{this.props.children}</Layout.Content>
        </Layout>
      </Layout>
    );
  }
}
